// Dados estruturados e configurações SEO para o site

export const siteConfig = {
  name: "Estação Marina da Rocha",
  description: "Estação: o seu ponto de encontro no Altiplano Leste.",
  url: "https://estacaomarina.com.br",
  logo: "https://estacaomarina.com.br/logo.png",
  phone: "+55-61-99691-9001",
  email: "estacaocrdf@gmail.com",
  address: {
    street: "Av. Altiplano Leste",
    neighborhood: "Marina da Rocha",
    city: "Brasília",
    state: "DF",
    zipCode: "71680-900",
    country: "Brasil"
  },
  coordinates: {
    latitude: -15.7801234,
    longitude: -47.8901234
  },
  socialMedia: {
    facebook: "https://facebook.com/estacaomarina",
    instagram: "https://instagram.com/estacaomarina",
    twitter: "https://twitter.com/estacaomarina",
    youtube: "https://youtube.com/estacaomarina"
  },
  businessHours: [
    {
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "06:00",
      closes: "23:00"
    }
  ]
};

// Dados estruturados para a organização principal
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": siteConfig.name,
  "description": siteConfig.description,
  "url": siteConfig.url,
  "logo": siteConfig.logo,
  "telephone": siteConfig.phone,
  "email": siteConfig.email,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": siteConfig.address.street,
    "addressLocality": siteConfig.address.neighborhood,
    "addressRegion": siteConfig.address.state,
    "postalCode": siteConfig.address.zipCode,
    "addressCountry": siteConfig.address.country
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": siteConfig.coordinates.latitude,
    "longitude": siteConfig.coordinates.longitude
  },
  "sameAs": Object.values(siteConfig.socialMedia),
  "openingHoursSpecification": siteConfig.businessHours.map(hours => ({
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": hours.dayOfWeek,
    "opens": hours.opens,
    "closes": hours.closes
  }))
};

// Dados estruturados para o local de negócios
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "ShoppingCenter",
  "name": siteConfig.name,
  "description": siteConfig.description,
  "url": siteConfig.url,
  "logo": siteConfig.logo,
  "telephone": siteConfig.phone,
  "email": siteConfig.email,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": siteConfig.address.street,
    "addressLocality": siteConfig.address.neighborhood,
    "addressRegion": siteConfig.address.state,
    "postalCode": siteConfig.address.zipCode,
    "addressCountry": siteConfig.address.country
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": siteConfig.coordinates.latitude,
    "longitude": siteConfig.coordinates.longitude
  },
  "openingHoursSpecification": siteConfig.businessHours.map(hours => ({
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": hours.dayOfWeek,
    "opens": hours.opens,
    "closes": hours.closes
  })),
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Estacionamento Gratuito",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Acessibilidade",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Wi-Fi Gratuito",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Ar Condicionado",
      "value": true
    }
  ],
  "hasMap": `https://maps.google.com/?q=${siteConfig.coordinates.latitude},${siteConfig.coordinates.longitude}`,
  "sameAs": Object.values(siteConfig.socialMedia)
};

// Dados estruturados para breadcrumbs
export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// Dados estruturados para eventos
export const getEventSchema = (event) => ({
  "@context": "https://schema.org",
  "@type": "Event",
  "name": event.name,
  "description": event.description,
  "startDate": event.startDate,
  "endDate": event.endDate,
  "location": {
    "@type": "Place",
    "name": siteConfig.name,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": siteConfig.address.street,
      "addressLocality": siteConfig.address.neighborhood,
      "addressRegion": siteConfig.address.state,
      "postalCode": siteConfig.address.zipCode,
      "addressCountry": siteConfig.address.country
    }
  },
  "organizer": {
    "@type": "Organization",
    "name": siteConfig.name,
    "url": siteConfig.url
  },
  "offers": event.price ? {
    "@type": "Offer",
    "price": event.price,
    "priceCurrency": "BRL",
    "availability": "https://schema.org/InStock"
  } : undefined
});

// Dados estruturados para lojas
export const getStoreSchema = (store) => ({
  "@context": "https://schema.org",
  "@type": "Store",
  "name": store.name,
  "description": store.description,
  "url": `${siteConfig.url}/loja/${store.id}`,
  "telephone": store.phone,
  "email": store.email,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": `${siteConfig.address.street} - ${store.andar}`,
    "addressLocality": siteConfig.address.neighborhood,
    "addressRegion": siteConfig.address.state,
    "postalCode": siteConfig.address.zipCode,
    "addressCountry": siteConfig.address.country
  },
  "openingHoursSpecification": store.hours ? [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    "opens": "09:00",
    "closes": "22:00"
  }] : undefined,
  "aggregateRating": store.rating ? {
    "@type": "AggregateRating",
    "ratingValue": store.rating,
    "reviewCount": store.reviewCount || 0
  } : undefined,
  "priceRange": store.priceRange || "$$",
  "image": store.image,
  "sameAs": store.socialMedia ? Object.values(store.socialMedia) : undefined
});

// Dados estruturados para FAQ
export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

// Dados estruturados para artigos/blog
export const getArticleSchema = (article) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.title,
  "description": article.description,
  "image": article.image,
  "author": {
    "@type": "Organization",
    "name": siteConfig.name
  },
  "publisher": {
    "@type": "Organization",
    "name": siteConfig.name,
    "logo": {
      "@type": "ImageObject",
      "url": siteConfig.logo
    }
  },
  "datePublished": article.publishedDate,
  "dateModified": article.modifiedDate || article.publishedDate,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": article.url
  }
});

// Configurações de SEO por página
export const seoConfig = {
  homepage: {
    title: "Estação Marina da Rocha",
    description: "Estação: o seu ponto de encontro no Altiplano Leste.",
    keywords: "centro comercial, Altiplano Leste, lojas, restaurantes, serviços, eventos, Brasília, estacionamento",
    structuredData: [organizationSchema, localBusinessSchema]
  },
  storeDirectory: {
    title: "Lojas e Serviços - Estação Marina",
    description: "Descubra lojas e serviços no Estação Marina da Rocha.",
    keywords: "lojas, diretório, restaurantes, moda, beleza, serviços, Estação Marina, Altiplano Leste",
    structuredData: [organizationSchema]
  },
  events: {
    title: "Eventos e Promoções - Estação Marina",
    description: "Confira nossa agenda de eventos e promoções especiais no Estação Marina. Shows, workshops, feiras e ofertas imperdíveis!",
    keywords: "eventos, promoções, shows, workshops, feiras, ofertas, Estação Marina",
    structuredData: [organizationSchema]
  },
  contact: {
    title: "Contato e Localização - Estação Marina",
    description: "Entre em contato com o Estação Marina. Endereço, telefone, horários e como chegar. Estamos na Marina da Rocha, Brasília.",
    keywords: "contato, localização, endereço, telefone, horários, como chegar, Marina da Rocha, Brasília",
    structuredData: [organizationSchema, localBusinessSchema]
  },
};

// Função para gerar meta tags dinâmicas
export const generatePageSEO = (page, customData = {}) => {
  const config = seoConfig[page] || seoConfig.homepage;
  return {
    title: customData.title || config.title,
    description: customData.description || config.description,
    keywords: customData.keywords || config.keywords,
    canonical: customData.canonical || `/${page}`,
    ogImage: customData.ogImage || "/og-image.jpg",
    ogType: customData.ogType || "website",
    structuredData: customData.structuredData || config.structuredData,
    noindex: customData.noindex || config.noindex || false,
    nofollow: customData.nofollow || config.nofollow || false
  };
};
